import { createActionGroup, props } from '@ngrx/store';
import { NavigationDescription } from '../../../../core/models/navigation-description';
import {
    PdfTitleImageDto,
    CreatePdfTitleImageDto,
    UpdatePdfTitleImageDto
} from "@travel-planner/library-travel-planner-api";
import { ApiError } from '../../../../core/models/api-error';

export const PdfTitleImagesActions = createActionGroup({
    source: 'PdfTitleImages',
    events: {
        'Load Pdf Title Images': props<{
            searchTerm?: string;
            locations?: number[];
            lastPdfTitleImageId?: number;
            includeTotal?: boolean;
        }>(),
        'Load Pdf Title Images Success': props<{
            pdfTitleImages: PdfTitleImageDto[];
            total?: number;
        }>(),
        'Load Pdf Title Images Failure': props<{ error: ApiError }>(),
        'Scroll Pdf Title Images List': props<{ scrollPosition: number; }>(),
        'Load Pdf Title Image': props<{ id: number }>(),
        'Load Pdf Title Image Success': props<{ pdfTitleImage: PdfTitleImageDto }>(),
        'Load Pdf Title Image Failure': props<{ id: number; error: ApiError }>(),
        'Update Form Control': props<{ property: string; value: any; }>(),
        'Add Pdf Title Image': props<{ pdfTitleImage: CreatePdfTitleImageDto; file?: File }>(),
        'Add Pdf Title Image Success': props<{ pdfTitleImage: PdfTitleImageDto; navigateOnSuccess?: NavigationDescription; }>(),
        'Add Pdf Title Image Failure': props<{ error: ApiError }>(),
        'Update Pdf Title Image': props<{ id: number; pdfTitleImage: UpdatePdfTitleImageDto; file?: File; navigateOnSuccess?: NavigationDescription; }>(),
        'Update Pdf Title Image Success': props<{ pdfTitleImage: PdfTitleImageDto; navigateOnSuccess?: NavigationDescription; }>(),
        'Update Pdf Title Image Failure': props<{ id: number; error: ApiError }>(),
        'Delete Pdf Title Image': props<{ id: number }>(),
        'Delete Pdf Title Image Success': props<{ id: number; navigateOnSuccess?: NavigationDescription; }>(),
        'Delete Pdf Title Image Failure': props<{ id: number; error: ApiError, ignoreGlobalError?: boolean }>(),
        'Upload Image': props<{ id: number; file: File; isNew?: boolean; navigateOnSuccess?: NavigationDescription; }>(),
        'Upload Image Success': props<{ pdfTitleImage: PdfTitleImageDto; navigateOnSuccess?: NavigationDescription; }>(),
        'Upload Image Failure': props<{ id: number; error: ApiError }>(),
    }
});
